module.exports = __webpack_public_path__ + "static/media/image2.0ad11ec7.jpg";